module.exports = __webpack_public_path__ + "static/media/cv.c0b640db.png";